import { OrderPaymentResponse } from '@woolworthsnz/trader-api';

const paymentTypes = Object.freeze({
	edr: 'ERV',
	visa: 'visa',
	mastercard: 'mastercard',
	jcb: 'jcb',
	amex: 'amex',
	unionpay: 'unionpay',
});

const directDebitMethod = 'DirectDebit';

export interface EdrAnayticsData {
	amount?: number;
	edrVoucherUsed: boolean;
}

export const isEdrVoucherUsed = (payments?: Array<OrderPaymentResponse> | undefined): EdrAnayticsData => {
	if (payments === undefined) {
		return { amount: 0, edrVoucherUsed: false };
	}

	const edrPayment = payments.find((payment) => payment.paymentType === paymentTypes.edr);
	return { amount: edrPayment?.amount ?? 0, edrVoucherUsed: edrPayment !== undefined };
};

export const getPaymentMethod = (payments: Array<OrderPaymentResponse> | undefined): string =>
	payments !== undefined && payments.filter((payment) => payment.paymentType !== paymentTypes.edr).length > 0
		? payments
				.filter((payment) => payment.paymentType !== paymentTypes.edr)
				.map((payment) => payment.paymentMethodType)
				.join(', ')
		: directDebitMethod;
